export default {
  init() {
    // JavaScript to be fired on all pages
    this.scrollHeader();
    this.phoneMask();
    this.magnificPopup();
    this.callModal();
  },

  scrollHeader() {
    $(window).scroll(function () {
      let scroll = $(window).scrollTop();
      if (scroll >= 50) {
        $('.banner').addClass('scrolled');
      } else {
        $('.banner').removeClass('scrolled');
      }
    });

    $(window).scroll(function(){
      if ($(this).scrollTop() > 140) {
        $('.fix-label').fadeIn().addClass('.act');
      } else {
        $('.fix-label').fadeOut().removeClass('.act');
      }
    });

    $('.scrollup').click(function(){
      $('html, body').animate({ scrollTop: 0 }, 600);
      return false;
    });
  },

  phoneMask() {
    /*$('input[type="tel"]').mask('+7 (999) 999-9999');*/
  },

  magnificPopup() {
    /*$('.service-page__gallery-item-image').magnificPopup({
      type: 'image',
      gallery: {
        enabled: true,
        tCounter: '%curr% из %total%',
      },
      callbacks: {
        elementParse: function (qw) {
          qw.src = qw.el.attr('src');
        },
      },
    });*/
  },

  callModal() {
    $('.button, .content-info__footer-call').on('click', function (e) {
      e.preventDefault();
      $('.modal__wrapper').fadeIn(250);
      $('#wpcf7-f417-o1').fadeIn(250);
      $('#wpcf7-f417-o2').fadeIn(250);
      $('#wpcf7-f417-o3').fadeIn(250);
    });

    $('.modal__wrapper, .modal__block-close-modal').on('click', (e) => {
      if ($(e.target).hasClass('modal__wrapper') || $(e.target).hasClass('modal__block-close-modal')) {
        $('.modal__wrapper').fadeOut(250);
        $('.modal__block > .wpcf7').fadeOut(250);
      }
    });
  },

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $('.navi').on('click', function (e) {
      e.preventDefault();
      $(this).toggleClass('navi--active');
      $('.banner__nav-primary').toggleClass('banner__nav-primary--active');
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js